/**
 * vue/cli配置，以下任意一个配置修改都需要重启项目
 */
module.exports = {
  // 开发环境端口号
  devPort: 8023,
  // 开发环境，启动完成后是否自动打开浏览器
  devOpenBrowser: false,
  // 是否开启 Gzip 打包
  buildGzip: true
}
